<template>
  <el-select
    v-model="bindVal"
    filterable
    remote
    :filter-method="dataFilter"
    :placeholder="placeholder"
    @change="handleChange"
  >
    <el-option
      :value="option.nation_phone_code"
      v-for="option in options"
      :key="option.id">{{option.nation_name + ' +' + option.nation_phone_code}}</el-option>
  </el-select>
</template>

<script>
/**
 * 国家代码选择器
 */

export default {
  name: 'CountryCodeSelect',
  props: {
    value: {
      type: [String, Boolean, Number]
    },
    placeholder: {
      type: String
    }
  },
  data() {
    return {
      bindVal: '',
      optionsOri: [],
      options: []
    };
  },
  created() {
    this.bindVal = this.value;

    this.$store.dispatch("getCountryList").then(data => {
      this.options = data;
      this.optionsOri = data;
    })
  },
  watch: {
    value() {
      this.bindVal = this.value;
    }
  },
  methods: {
    handleChange(value) {
      // 还原数组
      this.options = this.optionsOri;

      // 模拟formItem, 实现v-model
      this.$emit('input', value);
      this.$emit('change', value);
    },
    dataFilter(val) {
      // val存在
      if (val) {
        this.options = this.optionsOri.filter((item) => {
          if (!!~item.nation_phone_code.indexOf(val) || !!~item.nation_name.indexOf(val) || !!~item.nation_name.toUpperCase().indexOf(val.toUpperCase())) {
            return true
          }
        })
      // val为空时，还原数组
      } else {
        this.options = this.optionsOri;
      }
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .el-input__suffix{
  display: none;
}
/deep/ .el-input--suffix .el-input__inner{
  padding-left: 3px ;
  padding-right: 0;
}
/deep/ .el-input__inner{
  background: #f5f7fa;
  color: #909399;
}
</style>
